import * as axios from 'axios';

// var upload = function(formData) {
//   console.log(formData);
//   const url = `${BASE_URL}/api/v1/member/thumb`;
//   return axios.post(url ,{
//     email: 'user@gmail.com',
//     file: formData
//   }).then(x => x.data);
//   //return axios.post(url, {
//   //email: email,
//   //file: formData
//   //}).then(x => x.data);
// };
var upload = function(formData) {
  const url = 'http://rtaf.live/api/v1/member/thumb';
  return axios.post(url, formData)
    .then(x => x.data);
};

export { upload };
